import axios from 'axios';
import type { PMWorksheet } from '@/models/pmworksheet';
import type { PMLesson } from '@/models/pmlesson';

class PMWorksheetWebservice {
    public getById(worksheetId: number) {
        return axios.get<PMWorksheet>('/pmworksheets/getById', {
            params: {
                worksheetId,
            },
        });
    }

    public store(pmWorksheet: PMWorksheet, pmLessons: PMLesson[]) {
        return axios.post('/pmworksheets/store', {
            projectId: pmWorksheet.project.id,
            pmphaseId: pmWorksheet.pm_phase.id,
            pmLessons,
        });
    }

    public update(pmWorksheet: PMWorksheet, pmLessons: PMLesson[]) {
        return axios.post('/pmworksheets/update', {
            worksheetId: pmWorksheet.id,
            pmLessons,
        });
    }

    public remove(pmWorksheet: PMWorksheet) {
        return axios.post('/pmworksheets/remove', {
            id: pmWorksheet.id,
        });
    }
}

export const pmWorksheetWebservice = new PMWorksheetWebservice();
